export const SET_CARD_FILTERS = "app/Filter/SET_CARD_FILTERS";
export const SET_CARD_VIEW = "app/Filter/SET_CARD_VIEW";
export const SET_POSTER_FILTERS = "app/Filter/SET_POSTER_FILTERS";

export const SET_BLOG_FETCHER = "app/Filter/SET_BLOG_FETCHER";
export const SET_BLOG_FILTERS = "app/Filter/SET_BLOG_FILTERS";

export const SET_NEWS_FETCHER = "app/Filter/SET_NEWS_FETCHER";
export const SET_NEWS_FILTERS = "app/Filter/SET_NEWS_FILTERS";

export const SET_ENQ_FETCHER = "app/Filter/SET_ENQ_FETCHER";
export const SET_ENQ_FILTERS = "app/Filter/SET_ENQ_FILTERS";

export const SET_REV_FETCHER = "app/Filter/SET_REV_FETCHER";
export const SET_REV_FILTERS = "app/Filter/SET_REV_FILTERS";

export const SET_QR_FILTERS = "app/Filter/SET_QR_FILTERS";

export const SET_INV_FETCHER = "app/Filter/SET_INV_FETCHER";
export const SET_INV_FILTERS = "app/Filter/SET_INV_FILTERS";

export const SET_RES_FETCHER = "app/Filter/SET_RES_FETCHER";
export const SET_RES_FILTERS = "app/Filter/SET_RES_FILTERS";

export const SET_OVERVIEW_FILTERS = "app/Filter/SET_OVERVIEW_FILTERS";
export const SET_HEADLINE_FILTERS = "app/Filter/SET_HEADLINE_FILTERS";
export const SET_DASHBOARD_FILTERS = "app/Filter/SET_DASHBOARD_FILTERS";

export const SET_SURVEY_FETCHER = "app/Filter/SET_SURVEY_FETCHER";
export const SET_SURVEY_FILTERS = "app/Filter/SET_SURVEY_FILTERS";

export const RESET_ENQ_FILTERS = "app/Filter/RESET_ENQ_FILTERS";
export const SET_REPORT_FILTERS = "app/Filter/SET_REPORT_FILTERS";

export const SET_SURVEY_DATA = "app/Filter/SET_SURVEY_DATA";

export const SET_EMP_FETCHER = "app/Filter/SET_EMP_FETCHER";
export const SET_EMP_FILTERS = "app/Filter/SET_EMP_FILTERS";

export const SET_WEBENQ_FETCHER = "app/Filter/SET_WEBENQ_FETCHER";
export const SET_WEBENQ_FILTERS = "app/Filter/SET_WEBENQ_FILTERS";
